<template>
    <Dialog v-model:visible="visible" :style="{ width: '500px' }" :header="header" :modal="true" :dismissableMask="true" @hide="$emit('hide-dialog', true)">
        <div class="surface-section">
            <ul class="list-none p-0 m-0 preview-section">
                <li class="border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-4 font-medium">{{ mode === 'renew' ? 'Renewal Period' : 'Suspended Months' }}</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                        <Dropdown v-if="mode === 'renew'" id="renewDate" v-model="months" :options="periods" optionLabel="label" optionValue="value" placeholder="Select renewal period" class="w-full md:w-20rem" />
                        <InputNumber v-else v-model="months" :useGrouping="false" :min="1" placeholder="Input months value" class="w-full md:w-20`rem" />
                    </div>
                </li>
                <small class="p-invalid" v-if="submitted && !months">Renewal Period is required.</small>
                <li class="border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-4 font-medium">Notified Users</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                        <MultiSelect v-model="notifiedUsers" :filter="true" :options="users" optionLabel="fullname" :maxSelectedLabels="2" optionValue="id" display="chip" placeholder="Select users to notify" class="w-full md:w-20rem" />
                    </div>
                </li>
            </ul>
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="visible = false" />
            <Button label="Renew" icon="pi pi-check" class="ml-2 p-button-primary" @click="submit" />
        </template>
    </Dialog>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { ref, defineProps, defineEmits } from 'vue';
import { licenseStore, userStore } from '@/store/global-stores';

const emit = defineEmits(['hide-dialog']);
const props = defineProps({
    license: {
        type: Object,
        required: true,
    },
    mode: {
        type: String,
        required: true,
    },
});

const { periods } = storeToRefs(licenseStore);
const { users } = storeToRefs(userStore);

const license = ref(props.license);
const mode = ref(props.mode);
const header = (mode.value === 'renew' ? 'Renew' : 'Suspend') + ' license for ' + license.value.company_name;

const months = ref(null);
const notifiedUsers = ref([]);
const visible = ref(true);
const submitted = ref(false);

const submit = async () => {
    submitted.value = true;
    // check if renewal period is selected or no
    if (months.value) {
        const bodyParams = {
            id: license.value.id,
            months: months.value,
            notified_users: notifiedUsers.value,
        };
        const licenseUpdate = mode.value === 'renew' ? await licenseStore.renewLicense(bodyParams) : await licenseStore.suspendLicense(bodyParams);
        if (licenseUpdate) {
            submitted.value = false;
            emit('hide-dialog', true);
        }
    }
};
</script>
